angular.module('app').config(accountsRouting);

function accountsRouting($routeProvider) {
  $routeProvider
    .when('/accounts', {
      pageTitle: 'ACCOUNTS',
      template: '<accounts-page></accounts-page>',
      current: 'accounts',
      accessPermission: 'index_account_superadmin',
      authReq: true,
    })
    .when('/accounts/new', {
      template: '<account-page></account-page>',
      pageTitle: 'ADD_ACCOUNT',
      breadcrumb: {
        label: 'ACCOUNTS',
        parent: 'accounts',
      },
      current: 'accounts',
      accessPermission: 'create_account_superadmin',
      authReq: true,
    })
    .when('/accounts/:id', {
      // params: {
      //   mode: null,
      // },
      template: '<account-page></account-page>',
      pageTitle: 'EDIT_ACCOUNT',
      breadcrumb: {
        label: 'ACCOUNTS',
        parent: 'accounts',
      },
      current: 'accounts',
      accessPermission: 'update_account_superadmin',
      authReq: true,
    });
}

accountsRouting.$inject = ['$routeProvider'];
